export default {
  appvue: null,
  $store: null,
  stakeinfovue: null,

  topnavvue: {},
  topnavAccountBtnVue: {},

}